import { useRecordPageView } from 'hooks/analytics/useRecordPageView';
import useFirebaseSession from 'hooks/useFirebaseSession';
import { useRouter } from 'next/router';
import { useState, useEffect, useContext } from 'react'
import { PagePropsContext } from './Homepage.contexts';
import { HomepageState } from './Homepage.types';

export function useHomepageState(): HomepageState {
      const [showPopup, setShowPopup] = useState(false);
      const { userIsLoggedIn } = useFirebaseSession();

      useEffect(() => {
        var listener = () => {
          //@ts-ignore
          if (global.window.scrollY > 1280) {
            setShowPopup(true);
            global.window.removeEventListener("scroll", listener);
          }
        };
        global.window.addEventListener("scroll", listener);
      });

      const [gaLoaded, setGaLoaded] = useState(false);

      setInterval(() => {
        //@ts-ignore
        if (global.window?.ga && !gaLoaded) {
          setGaLoaded(true);
        }
      }, 100);

      useEffect(() => {
        if (gaLoaded) {
          //@ts-ignore
          global.window?.ga("send", "pageview");
        }
      }, [gaLoaded]);

      const {
        query: { hideHero },
      } = useRouter();

      const shouldHideHero = !!hideHero;

      useRecordPageView();

      return {
        shouldHideHero,
        userIsLoggedIn,
        showPopup,
      };
}

export function usePageProps() {
  const pageProps = useContext(PagePropsContext)
  return pageProps
}